"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = void 0;
var _menuModule = _interopRequireDefault(require("@albelli/arc-3/lib/menu.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _MenuLink = require("./MenuLink");
var _MenuList = require("./MenuList");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MenuItem = _ref => {
  let {
    hideForMobile,
    hideForNonMobile,
    ...props
  } = _ref;
  const liClasses = (0, _classnames.default)(_menuModule.default["arc3-menu__dropdown"], {
    "arc3-hide-for-small": hideForMobile,
    "arc3-hide-for-medium-up": hideForNonMobile
  });
  return /*#__PURE__*/_react.default.createElement("li", {
    className: liClasses,
    "data-cy": props.items && props.items.length ? "MenuItemWithItems" : "MenuItem"
  }, /*#__PURE__*/_react.default.createElement(_MenuLink.MenuLink, props), /*#__PURE__*/_react.default.createElement(_MenuList.MenuList, _extends({}, props, {
    style: {
      display: props.expanded === props.text ? "block" : ""
    }
  })));
};
exports.MenuItem = MenuItem;